/// <amd-module name="SuiteCommerce.ItemRecSys.LogParameters"/>
define("SuiteCommerce.ItemRecSys.LogParameters", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EventType = void 0;
    var EventType;
    (function (EventType) {
        EventType["WIDGET_SHOWN"] = "widgetShown";
        EventType["WIDGET_CLICKED"] = "widgetClicked";
        EventType["WIDGET_CAROUSELLED"] = "widgetCarouselled";
        EventType["ERROR"] = "error";
    })(EventType || (exports.EventType = EventType = {}));
});
